import React from "react";
import ProductPermissionDenied from "../Dragger/ProductPermissionDenied";
import { PRODUCT_PERMISSION_MESSAGES } from "../../hooks/useAdminPermissions";

const CoiCertificateViewOnlyEmpty = ({ manageSwitch, setManageSwitch }) => {
  const handleEnglishSwitch = () => setManageSwitch(false);
  const handleSpanishSwitch = () => setManageSwitch(true);

  return (
    <>
      <div className="switches-container mb-30">
        <div className="mempro" onClick={handleEnglishSwitch}>
          English
        </div>
        <div className="mempro" onClick={handleSpanishSwitch}>
          Spanish
        </div>
        <div
          className={
            !manageSwitch ? "switch-wrapper" : "switch-wrapper switchside"
          }
        >
          <div className="switch">
            {!manageSwitch ? <div>English</div> : <div>Spanish</div>}
          </div>
        </div>
      </div>
      <p className="heedprodct mb-20">Certificate</p>
      <div className="sectionpadding bg-white mb-30">
        <ProductPermissionDenied
          message={PRODUCT_PERMISSION_MESSAGES.CERTIFICATE}
        />
      </div>
    </>
  );
};

export default CoiCertificateViewOnlyEmpty;
